import React from "react";

const FileUploadConformationModal = ({ isOpen, onClose, onConfirm, file }) => {
  if (!isOpen) return null; // Modal ko show karne ke liye isOpen true hona chahiye

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-1/3">
        <h2 className="text-xl mb-4">
          Are you sure you want to upload a file?
        </h2>
        <div className="mt-4 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileUploadConformationModal;
